import { extract } from './extract-util.js';
import { globalSprinkles } from './safe-sprinkles.js';
import { type SpacingProperties } from './sprinkle-properties.js';

/**
 * Defines the box gap props.
 * @public
 */
export interface GapProps {
  /** Defines gap */
  gap?: SpacingProperties;
  /** Defines row gap */
  rowGap?: SpacingProperties;
  /** Defines column gap */
  columnGap?: SpacingProperties;
}

/**
 * Keys that will define the gap of a component.
 * @public
 */
const gapPropKeys: Array<keyof GapProps> = ['gap', 'rowGap', 'columnGap'];

/**
 * Given a set of props will return the relevant class names for the gap sprinkles
 * and the remaining props.
 * @internal
 */
export function getGapSprinkles<T extends GapProps>(
  props: T,
  defaults: Partial<GapProps> = {},
): [className: string, remainingProps: Omit<T, keyof GapProps>] {
  const { extracted, rest } = extract(props, gapPropKeys);
  const { extracted: extractedDefaults } = extract(defaults, gapPropKeys);

  return [
    globalSprinkles({
      ...extractedDefaults,
      ...extracted,
    }),
    rest,
  ];
}
